// This import loads the firebase namespace along with all its type information.
import Comment from './comment-model'

export async function load_comments(): Promise<Comment[]> {
  throw 'Not implemented'
}

export async function delete_comment(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_comment(): Promise<Comment> {
  throw 'Not implemented'
}
